/*
 * inspired by
 * https://stackoverflow.com/questions/32553158/detect-click-outside-react-component
 *
 * Allows a component to react to clicks outside a component, when onBlur is not sufficient.
 *
 * Example:
 *
 *    const containerRef = createRef<HTMLDivElement>();
 *    useOutsideClick(containerRef, () => alert('you clicked elsewhere'));
 *    return <div ref={containerRef}>some stuff</div>;
 */

import React, { useEffect } from 'react';

function useOutsideClick(ref:React.RefObject<HTMLElement>, callback:() => void) {
  useEffect(() => {
    /**
     * If someone clicks outside this component, call the callback
     */
    function handleClickOutside(this : Document, event: MouseEvent) : void {
        const targetElement = event.target as HTMLElement;
        if (ref && ref.current && !ref.current.contains(targetElement)) {
            callback();
        }
    }

    if (document) {
      // Bind the event listener
      document.addEventListener<"mousedown">("mousedown", handleClickOutside);
      return () => {
          // Unbind the event listener on clean up
          document.removeEventListener("mousedown", handleClickOutside);
      };
    }
    return
  }, [ref, callback]);
 }

 export default useOutsideClick;
